import React, { useState, useEffect } from 'react';
import Day from 'dayjs';
import utc from 'dayjs/plugin/utc';
import Price from "components/Price";
import PropTypes from 'prop-types';
import RadioButton from 'components/RadioButton';
import style from './style.scss'; //NOSONAR

const Hours = ({ hour, callback }) => {
    const [selectInput, setSelectInput] = useState(false);

    if (!hour) return '';

    useEffect(() => {
        setSelectInput(hour.selected);
    }, [hour.selected]);

    const formatHour = (date) => {
        return Day.extend(utc)(date).utc().format('HH:mm');
    }

    return (
        <div className="date-delivery-hours-wrap">
            <RadioButton item={selectInput} name={'date-delivery'} callbackSelect={() => callback(hour, !selectInput)} />
            <div className="date-delivery-hours-and-price">
                <span onClick={() => { callback(hour, !selectInput) }} className={"date-delivery-hour"}>
                    {hour.formatExpress
                        ? `Antes de las ${formatHour(hour.endDateUtc)} hrs.`
                        : `${formatHour(hour.startDateUtc)} a ${formatHour(hour.endDateUtc)}`}
                </span>
                <span className="date-delivery-price"><Price price={((hour.price || hour.listPrice) ? ((hour.price / 100) || hour.listPrice) : 0)} /></span>
            </div>
        </div>
    )
}

Hours.propTypes = {
    hour: PropTypes.object,
    expressFlag: PropTypes.bool,
    callback: PropTypes.func,
};

export default Hours;
